import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const PartnerInfo = ({ partner }) => {
  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        {/* <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            거래처 종류
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.partnerTyp}
          </Typography>
        </Grid> */}
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            거래처 코드
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.partnerCd}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            산업체 유형
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" component="div">
            {partner?.incTyp}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            거래처명
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.partnerNm}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            여신한도
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.loanAmt}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            거래 유형
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.tradeTyp}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            사업자번호
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.regNumber}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            연락처
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.partnerPhone}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            주소
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" component="div">
            {partner?.partnerAddr}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            대표자명
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.president}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            은행명
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.bankName}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            계좌번호
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" component="div">
            {partner?.accountNumber}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            세금계산서 메일
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.taxEmail}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            세금계산서 담당자
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {partner?.taxContactNm}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            세금계산서 연락처
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" component="div">
            {partner?.taxContactPhone}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2" component="div">
            참고사항
          </Typography>
        </Grid>
        <Grid item xs={11}>
          <Typography
            variant="body2"
            component="div"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {partner?.partnerDesc}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PartnerInfo;
